import Decimal from 'decimal.js';

Decimal.set({ precision: 10, rounding: Decimal.ROUND_HALF_UP });

const isIntegerCurrency = (currencyCode?: string | null): boolean =>
  currencyCode === 'KRW';

export function roundPrice(
  value: number,
  currencyCode?: string | null,
): number {
  if (isIntegerCurrency(currencyCode)) {
    return new Decimal(value).toDecimalPlaces(0, Decimal.ROUND_DOWN).toNumber();
  }
  return new Decimal(value)
    .toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
    .toNumber();
}

export const formatAmountForServer = (
  amount: Decimal | string | number,
  currencyCode?: string | null,
): string => {
  const decimalAmount = amount ? new Decimal(amount) : new Decimal(0);

  if (isIntegerCurrency(currencyCode)) {
    return decimalAmount.toDecimalPlaces(0, Decimal.ROUND_DOWN).toFixed(0);
  }
  return decimalAmount.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toFixed(2);
};

export function getTotalPrice(
  price: number,
  quantity: number,
  currencyCode?: string | null,
): number {
  if (isIntegerCurrency(currencyCode)) {
    return new Decimal(price)
      .times(quantity)
      .toDecimalPlaces(0, Decimal.ROUND_DOWN)
      .toNumber();
  }
  return new Decimal(price)
    .times(quantity)
    .toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
    .toNumber();
}

export function formatPrice(
  num?: number | null,
  currencyCode?: string | null,
): string {
  if (typeof num !== 'number' || isNaN(num)) {
    return '';
  }

  if (isIntegerCurrency(currencyCode)) {
    return new Decimal(num)
      .toDecimalPlaces(0, Decimal.ROUND_DOWN)
      .toNumber()
      .toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
  }
  return new Decimal(num)
    .toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
    .toNumber()
    .toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
}

export function formatNumber(num?: number | null): string {
  if (typeof num !== 'number') {
    return '';
  }

  if (isNaN(num)) {
    return '';
  }

  return num.toLocaleString();
}
